import React from 'react';
import { Progress } from 'tea-component';
import "./index.scss"
const ProgressComponent = (porps: any) => {
  let { data } = porps;
  return (
    <div className="dbi-progress-component">
    <div className="progress-text">{data?.title}</div>
    <div className="progress-flex">
      <Progress
        className="progress-line"
        percent={data?.num ? Number(data?.num.slice(0,data?.num.indexOf('%'))) : 100}
        strokeColor={data?.color}
      />
      <div className="progress-num">{data?.num}</div>
    </div>
  </div>
  );
};

export default ProgressComponent;
